import React,{useEffect, useRef, useState} from 'react'
import { readableDate } from '../../common/set_date'
import { useDispatch, useSelector } from 'react-redux'
import ChatPopUp from '../../ChatBox/ChatPopUp'
import ChatPrompt from '../../ChatBox/ChatPrompt'
import { authTokens, sortCommentFunction, userInfo } from '../../../redux/Selectors/selectors'
import { useParams } from 'react-router-dom'
import { createDebateComment, debate_reaction_activity, deleteDebateComments,
        editDebateComment, getEachDebateCommentReplies, getEachDebateComments
     } from '../../../redux/Thunks/debatesThunk'
import CommentImpression from '../../Dashboard/DashCRUD/commentImpression'
import { arrayInputOnChange, changeArrayItemState, resetActions } from '../../common/show_and_hide'
import { sortingCategory } from '../../../redux/Slices/sharedUseEffectSlice'
import { Replies, ShowReplies } from '../../Dashboard/DashCRUD/Replies'
import { filterToUpdate, localFileUpload, replaceDataInArrayWithNewData } from '../../common/checks_Func'
import UploadedImagesDisplay from '../../Create/UploadedImagesDisplay'
import usePageVisibility from '../../common/pageVisibilty'




const DebateComments = ({data, reactions}) => {

  const { debate_id } = useParams()
  const dispatch = useDispatch()
  const tokens = useSelector(authTokens)
  const timeSpentRef = useRef(1)

  let userID;
  const user = useSelector(state => userInfo(state))
  if (user) {
      userID = user.id;
  }


  const [engagementData, setEngagementData] = useState({
    "content_type": "debate",
    "object_id": debate_id,
    "commented": false
  })
  

  const [popUp, setPopUp] = useState(false)

  const [comments_with_null_parent, setComments_with_null_parent] = useState([])
  const sortedBy = useSelector(sortingCategory)
  const sortedComments = sortCommentFunction(sortedBy, comments_with_null_parent)


  const [editAction, setEditAction] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [showHideReplies, setShowHideReplies] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [hideBox, setHideBox] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [moreAction, setMoreAction] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [toggleClick, setToggleClick] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));

  const [comment, setComment] = useState("")
  const [reply, setReply] = useState("")
  const [repliePerComment, setRepliesPerComment] = useState([])
  const [moreActionReply, setMoreActionReply] = useState([]);
  const [commentID, setCommentID] = useState("")
  const [commentMedia, setCommentMedia] = useState([])
  const [mediaUploadError, setMediaUploadError] = useState("")
  const [replyMedia, setReplyMedia] = useState([])
  const [replymediaUploadError, setReplyMediaUploadError] = useState("")
  let [inputValue, setInputValue] = useState(
      Array.from({ length: comments_with_null_parent.length }, () => "")
  );


  // SHOW AND HIDE REPLIES
  const [replyIndexClicked, setReplyIndexClicked] = useState(null)
  const handleClick = async (index, eid) => {
        resetActions(index, showHideReplies, setShowHideReplies)
  
        if(index === replyIndexClicked){
            setReplyIndexClicked(null)
            setRepliesPerComment([])
            changeArrayItemState(index, showHideReplies, setShowHideReplies)
            return
        } 
  
      const response = await dispatch(getEachDebateCommentReplies({comment_eid: eid})).unwrap() || []
      setRepliesPerComment(response)
      setMoreActionReply(Array.from({ length: response.length }, () => false))
      setReplyIndexClicked(index)
   }

  // SHOW AND HIDE REPLY INPUT
  const toggle_reply_box = (index) => {
      resetActions(index, comments_with_null_parent, setHideBox)
      setMoreAction(Array.from(
          { length: comments_with_null_parent.length },
          () => false
      ))
      setMoreActionReply(Array.from({ length: moreActionReply.length }, () => false))
  }

  // SHOW AND HIDE EDIT/DELETE CONTAINER FOR COMMENTS
  const show_more_actions = (index) => {
      changeArrayItemState(index, moreAction, setMoreAction)
  }

// SHOW AND HIDE EDIT/DELETE CONTAINER FOR REPLIES
const show_more_actions_reply = (index) => {
  changeArrayItemState(index, moreActionReply, setMoreActionReply)
}

  function removeMediaFromList(index, arrayToFilter, setArrayFunc) {
    setArrayFunc(arrayToFilter.filter((_, idx) => {
        return idx !== index
    }))
  }

  //ON COMMENT CHANGE
  const inputOnChange = (index, e) => {
      arrayInputOnChange(index, e, inputValue, setInputValue)
  }

  const handleCommentFile = (e, setError, mediaArray, setMediaArray) => {

      const validatedFiles = localFileUpload(e, setError, true)

      if (mediaArray.length > 0 && Array.isArray(validatedFiles)) {
        setMediaArray((prevValue) => {
              return [...validatedFiles, ...prevValue]
          });
      } else {
        const validData = Array.isArray(validatedFiles) && validatedFiles
        setMediaArray(validData)
      }

  };

  // POST COMMENT
const submitComment = async (e) => {
    e.preventDefault();
    toggle_reply_box()
    if (comment || commentMedia.length > 0) {
        try {
            const result = await dispatch(
                createDebateComment({
                    debate_id,
                    author: userID,
                    text: comment,
                    media: commentMedia,
                    parent: null
                })
            ).unwrap();

            setComment("")
            setCommentMedia([])
            setReplyMedia([])
            setRepliesPerComment([])
            setEngagementData((prevValue) => {
                return {
                    ...prevValue,
                    commented : true
                }
            })

            if(result?.message){
                setComments_with_null_parent((prevValue) => {
                    return [...prevValue, result?.message]
                })
            }

        } catch (error) {
            console.error("Error posting comment:", error);
        }
    }
}

  // POST REPLY
  const submitReply = async (id) => {
      toggle_reply_box()
      setReplyMedia([])
      if (reply) {
        try {
            const result = await dispatch(
                createDebateComment({
                  debate_id,
                  author: userID,
                  text: reply,
                  media: replyMedia,
                  parent: id
              })
              ).unwrap()

              setReply("")
              setEngagementData((prevValue) => {
                return {
                    ...prevValue,
                    commented : true
                }
            })

            if(result?.message){
                const found = comments_with_null_parent.find((item) => {
                    return item.eid === id 
                })
                const copyArray = {...found}
                copyArray["replies_total"]++

                const response = replaceDataInArrayWithNewData(comments_with_null_parent, copyArray, id)
                setComments_with_null_parent(response)
            }

        } catch (error) {
            console.error("Error posting reply:", error);
        }
      }


  }

  // SHOW THE EDIT INPUT BOX
  const handleEdit = (comment_id, index) => {
      setInputValue(
          comments_with_null_parent.map(({ text }) => {
              return text;
          })
      )
      resetActions(index, comments_with_null_parent, setEditAction)
      setCommentID(comment_id)
      show_more_actions(index)
      show_more_actions_reply(index)
  }

  // UPDATE COMMENT
  const confirmUpdate = async (comment_id, index) => {
    handleEdit();
    show_more_actions();
    show_more_actions_reply()
    toggle_reply_box();

    if (!inputValue[index]) {
        alert("This field cannot be empty!");
        return;
    }

    try {
        const response = await dispatch(
            editDebateComment({
                eid: comment_id,
                edited_comment: inputValue[index]
            })
        ).unwrap()

        if(response?.debate){
            const findData = comments_with_null_parent.findIndex((item) => item.eid === comment_id)
            const copiedData = [...comments_with_null_parent]
            copiedData[findData] = response
            setComments_with_null_parent(copiedData)
        }

    } catch (error) {
        console.error("Error updating comment:", error);
    }
}

// DELETE COMMENT
  const handleDelete = async () => {
    toggle_reply_box()
    if (commentID) {
        try {
            const response = await dispatch(
                deleteDebateComments({
                    eid: commentID
                })
            ).unwrap();

            // Remove comment from comments section
            if(response?.message){
                const filtered = filterToUpdate(comments_with_null_parent, commentID)
                const filtered2 = filterToUpdate(repliePerComment, commentID)
                
                setRepliesPerComment(filtered2)
                setComments_with_null_parent(filtered)
            }

            setPopUp(!popUp)

        } catch (error) {
            console.error("Error deleting comment:", error);
        }
    }
}


const reactionActivity = async (e, user_id, comment_id, index, parent_comment_outer_id) => {
    const x = [...toggleClick]
    x[index] = true

    setToggleClick(x)

    const value = e.target.id || e.target.parentElement.id

    if (value === "Thumbs_Up" || value === "Thumbs_Down"){
        await dispatch(
            debate_reaction_activity({
                  eid: comment_id,
                  user_id,
                  parent_id: debate_id,
                  vote_type: value === "Thumbs_Up" ?  'U' : 'D'
              })
          ).unwrap()
          await getCommentData(debate_id)

        if(parent_comment_outer_id){
        const response = await dispatch(getEachDebateCommentReplies({comment_eid : parent_comment_outer_id})).unwrap() || []
        setRepliesPerComment(response)
        }
    }
    
      await new Promise(resolve => setTimeout(resolve, 1500))

      const y = [...toggleClick]
      y[index] = false
      setToggleClick(y)
  }

  // SEND ENGAGEMENT DATA AS USER LEAVES PAGE
const sendEngageMentData = () => {

    const url = `${process.env.REACT_APP_SERVER_URL}/api/userfeed/engagements/${userID}/data-collection/`
    const data = {
        ...engagementData,
        time_spent : timeSpentRef.current,
        analytics_token : `Bearer ${tokens?.accessToken}`
    }

    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    navigator.sendBeacon(url, blob);

}
usePageVisibility(sendEngageMentData)


async function getCommentData(id){
    await dispatch(getEachDebateComments({ debate_id : id }))
    .then(({ payload }) => {
        if (Array.isArray(payload)) {
            const mainComment = payload?.filter(({ parent }) => parent === null);
            setComments_with_null_parent(mainComment)
        }
    });
}



useEffect(() => {
    setComments_with_null_parent(data)
    // eslint-disable-next-line
}, [data, sortedBy]);

useEffect(() => {

},[reactions])

useEffect(() => {
    const increaseTimeSpentOnPost = setInterval(() => {
        timeSpentRef.current += 1
    }, 1000);

    return () => clearInterval(increaseTimeSpentOnPost);
}, []);


  return (
      <div>

              <div className={` text-white 
                        ${ (Array.isArray(sortedComments) && sortedComments.length > 5) &&
                                "h-[85vh] overflow-y-scroll scroll-bar-in-dark pb-5 relative rounded-lg"
                                } `} >
                  {sortedComments &&

                    sortedComments.map(({ eid, debate, date_created, upvote_count, media,
                          downvote_count, text, author, deleted, replies_total }, index) => {


                        const userReactionData = reactions && reactions.find((item) => {
                            return item.object_id === eid && item
                          })
                          const date_object = readableDate(date_created)


                          return (
                              <div key={index} data-id={eid}>
                                  <CommentImpression
                                      id={eid}
                                      deleted={deleted}
                                      commentPoster={author?.id}
                                      author_ID={userID}
                                      index={index}
                                      username={author?.username}
                                      img={author?.user_image}
                                      comment_date={date_object}
                                      comment_text={text}
                                      commentMedia={media}
                                      upvote_count={upvote_count}
                                      downvote_count={downvote_count}
                                      replyComment={submitReply}
                                      reply={reply}
                                      handleReplyChange={e => setReply(e.target.value)}
                                      replyMedia={replyMedia}
                                      handleReplyFile={(e) => {
                                        handleCommentFile(e, setReplyMediaUploadError, replyMedia, setReplyMedia)
                                      }}
                                      replyMediaUploadError={replymediaUploadError}
                                      removeMediaFromReplyList={(idx) => {
                                        removeMediaFromList(idx, replyMedia, setReplyMedia)
                                      }}
                                      replyPromptShow={hideBox}
                                      edit_delete_div={moreAction}
                                      toggle_Click={toggleClick}
                                      edit_box={editAction}
                                      input_value={inputValue[index]}
                                      set_Input_Value={(e) => inputOnChange(index, e)}
                                      toggleReplyBox={() => {
                                          toggle_reply_box(index)
                                          changeArrayItemState(index, hideBox, setHideBox)
                                      }}
                                      showMoreActions={show_more_actions}
                                      cancelAction={() => {
                                          handleEdit()
                                          show_more_actions()
                                          toggle_reply_box()
                                      }}
                                      deleteComment={(comment_id) => {
                                          setCommentID(comment_id)
                                          setPopUp(!popUp)
                                      }}
                                      handleUpdate={confirmUpdate}
                                      editComment={handleEdit}
                                      setInputValue={e => setCommentID(e.target.value)}
                                      reaction={(e) => {
                                          reactionActivity(e, userID, eid, index)
                                      }}
                                      userReactionData={userReactionData}
                                  />

                                  <ShowReplies
                                      comment_eid={eid}
                                      index={index}
                                      repliesTotal={replies_total}
                                      seeReplies={handleClick}
                                      setArray={showHideReplies}
                                  />

                                  <Replies
                                      showHideReplies={showHideReplies}
                                      index={index}
                                      author_ID={userID}
                                      showMoreActions={show_more_actions_reply}
                                      edit_delete_div={moreActionReply}
                                      arrayToMap={repliePerComment}
                                      deleteComment={(comment_id) => {
                                          setCommentID(comment_id)
                                          setPopUp(!popUp)
                                      }}
                                      reaction={(e, innerCommentID) => {
                                          reactionActivity(e, userID, innerCommentID, null, eid)
                                      }}
                                      fetchedRxn={reactions}

                                  />

                                  <hr />
                              </div>
                          )
                      })
                  }
              </div>

         {/* Close of comments section below */}
                <div>
                <ChatPrompt
                    currentMode={true}
                    bgOnDark="bg-nightModeDark"
                    position="static"
                    placeholder="Post your comment here..."
                    submitPrompt={submitComment}
                    value={comment}
                    handleChange={(e) => {
                        setComment(e.target.value)
                    }}
                    mediaPresent={commentMedia.length > 0 && true}
                    showFileBTn={true}
                    selectFile={(e) => {
                        handleCommentFile(e, setMediaUploadError, commentMedia, setCommentMedia)
                    }}
                    id="debateCommentUpload"
                    />
                <p className='m-3 text-red-600 text-sm'>{mediaUploadError}</p>

                <div>
                <UploadedImagesDisplay
                media={commentMedia}
                removeMedia={(idx) => {
                    removeMediaFromList(idx, commentMedia, setCommentMedia)
                }
                    } />
                </div>
                </div>





          {/* POP UP */}
          {popUp && <ChatPopUp
              objectModel="Comment?"
              handleClosePopUp={() => setPopUp(!popUp)}
              handleCancel={() => setPopUp(!popUp)}
              promptTarget="This comment"
              handleDelete={handleDelete}

          />}




      </div>

  );
}

export default DebateComments
